import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

export interface AppSelectOption {
  label: string;
  value: string;
}

interface AppSelectInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: AppSelectOption[];
  error?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

const AppSelectInput = ({
  label,
  value,
  onChange,
  options,
  error,
  disabled = false,
  fullWidth = true,
}: AppSelectInputProps) => {
  return (
    <FormControl fullWidth={fullWidth} size="small" error={!!error}>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <MenuItem key={option.value || "empty"} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error ? <FormHelperText>{error}</FormHelperText> : null}
    </FormControl>
  );
};

export default AppSelectInput;
